module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }